import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        setError(null);
        try {
            await api.post("/auth/forgot-password", { email });
            setDone(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || "Errore. Riprova.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="co-container py-14 sm:py-20 max-w-md" data-testid="forgot-page">
            <span className="co-caption">Recupero Password</span>
            <h1 className="font-serif text-4xl mt-2 mb-8">Password dimenticata</h1>

            {done ? (
                <div className="space-y-6" data-testid="forgot-done">
                    <p className="text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
                        Se l'indirizzo è registrato, riceverai a breve un link per reimpostare la password.
                    </p>
                    <Link to="/login" className="co-btn-ghost inline-flex">
                        Torna al login
                    </Link>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-5">
                    <div>
                        <Label htmlFor="email" className="co-caption mb-2 block">Email</Label>
                        <Input
                            id="email" type="email" required autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="forgot-email-input"
                            className="bg-white h-11"
                        />
                    </div>
                    {error && <p className="text-sm text-[hsl(var(--destructive))]">{error}</p>}
                    <button type="submit" disabled={busy} className="co-btn-primary w-full h-12" data-testid="forgot-submit-btn">
                        {busy ? "Invio in corso…" : "Invia link"}
                    </button>
                </form>
            )}
        </div>
    );
}
